import { isSidebarFormatConfigEnabled } from '@atlassian/jira-platform-utils-number/src/index.tsx';

export default {
	get(): boolean {
		return isSidebarFormatConfigEnabled();
	},
};
